import { render } from "./App.vue?vue&type=template&id=1231229e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/css/common.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=1231229e&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__